export default "__VITE_ASSET__ea1df984__"